import { requestHandler } from '../../../api';

export const getFactoringRequestOperationEvaluation = async (
  dispatch: any,
  data: any,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/factoring/quote/${data.id}/operation/evaluation`,
    dispatch,
  });
  if (response) return response.data;
};

export const editFactoringRequestOperationEvaluation = async (
  dispatch: any,
  id: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'patch',
    url: `internal/factoring/quote/${id}/operation/evaluation`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const deleteFactoringRequestOperationEvaluation = async (
  dispatch: any,
  id: number,
  approvalId: any,
) => {
  const response = await requestHandler({
    method: 'delete',
    url: `internal/factoring/quote/${id}/operation/evaluation/${approvalId}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getFactoringRequestOperationMissingApprovals = async (
  dispatch: any,
  id: number,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/factoring/quote/${id}/operation/missingapprovals`,
    dispatch,
  });
  if (response) return response.data;
};

export const makeFactoringRequestOperationApproval = async (
  dispatch: any,
  id: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/factoring/quote/${id}/operation/approve`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const makeFactoringRequestOperationReject = async (
  dispatch: any,
  id: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/factoring/quote/${id}/operation/reject`,
    data,
    dispatch,
  });
  if (response) return response.data;
};
